// extracted by mini-css-extract-plugin
export default {"root":"style_root__AcLSA","abilities":"style_abilities__LmO2o"};